import {
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import CustomInput from "../../../Components/CustomInput";
import CustomSelect from "../../../Components/CustomSelect";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "./header";
import AdminPartnerClient from "../../../Service/Admin/partner_services";
import { GLOBAL_STEPPER_DATA } from "../../../Redux/actions";
import AddToListModal from "../../../Components/FormGenerator/addToListModal";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import StepperService from "./StepperService";
import { mappedKeyJSON } from "./MappedKeyJSON";
import CircularIndeterminate from "../../../Components/Loader";
import CustomSelectMulti from "../../../Components/CustomSelectMulti";
import { ObjectToFormdata } from "../../../Common/Utils/common_utils";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  labelText: {
    color: "#4D4F5C",
    fontSize: "16px",
    lineHeight: "22px",
  },
  autoComplete: {
    "& .MuiInputBase-input": {
      padding: "12px !important",
      fontSize: 16,
    },
    "& .MuiInput-underline:before": {
      content: "' '",
      border: "0px !important",
      transition: "none",
    },
    "& .MuiAutocomplete-popupIndicator": {
      marginRight: 5,
    },
    "& .MuiAutocomplete-inputRoot": {
      border: "1px solid rgba(0, 0, 0, 0.23)",
      borderRadius: 5,
    },
  },
}));
function OtherQuestions(props: any) {
  const classes = useStyles();

  const global_data = useSelector((state: any) => state.stepperReducer);
  const global_data_common = useSelector((state: any) => state.commonReducer);
  const dispatch = useDispatch();
  // @ts-ignore
  const globaluserData = useSelector((state) => state.commonReducer);
  const role = globaluserData?.role;

  const data = {
    assessment_hour_rate_id: "",
    available_date: "",
    coaching_hour_id: "",
    facilitation_day_rate_id: "",
    coach_currency_type: "",
    assessment_currency_type: "",
    mentoring_currency_type: "",
    facilitation_currency_type: "",
    coaching_program_currency_type: "",
    assessor_currency_type: "",
    facilitator_currency_type: "",
    psychometric_costs_currency_type_id: "",
    psychometric_costs: "",
    internal_comments: "",
    travel_expenses: "",
    considered_levels: "",
    coaching_hourly_rate_range: "",
    mentoring_day_rate_id: "",
    coaching_programme_rate_id: "",
  };
  const [userData, setUserData] = useState<any>(data);
  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [showAddNewModalExist, setShowAddNewModalExist] = useState(false);
  const [addNewModalProps, setAddNewModalProps] = useState({});
  const [cityArr, setCityArr] = useState([]);
  const [travelExpenseArr, setTravelExpense] = useState([]);
  const [coachingHourRateArr, setCoachingHourRateArr] = useState([]);
  const [facilitationDayRateArr, setFacilitationDayRateArr] = useState([]);
  const [assessmentDayRateArr, setAssessmentDayRateArr] = useState([]);
  const [mentoringDayRateArr, setMentoringDayRateArr] = useState([]);
  const [coachingProgrammeRateArr, setCoachingProgrammeRateArr] = useState([]);

  const [addNewFlag, setAddNewFlag] = useState(false);
  const [currencyArr, setCurrencyArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [local_tx_areasArr, setLocal_tx_areasArr]: any = useState([]);
  const [local_tx_areas_attribute, setLocal_tx_areas_attribute]: any = useState(
    []
  );
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [deliveryMethodArr, setDeliveryMethodArr]: any = useState([]);
  const [deliveryMethod_attribute, setDeliveryMethod_attribute]: any = useState(
    []
  );
  const [levelArr, setLevelArr]: any = useState([]);
  const [level_attribute, setLevel_attribute]: any = useState([]);

  const filteredCurrencyArr = currencyArr.slice(0, 3);

  const addNewHandler = (
    addNewModalExistFlag: any,
    modalFlag: any,
    addNewModalPropsData: any
  ) => {
    setShowAddNewModalExist(addNewModalExistFlag);
    setShowAddNewModal(modalFlag);
    setAddNewModalProps({ ...addNewModalProps, ...addNewModalPropsData });
  };
  useEffect(() => {
    local_tx_areasArr.length = 0;
    setLocal_tx_areasArr(
      local_tx_areasArr.concat(
        global_data_common.partnerDropdowns[mappedKeyJSON.City]
      )
    );
    levelArr.length = 0;
    var pdata = [
      ...global_data_common.partnerDropdowns[mappedKeyJSON.Level],
      {
        id: global_data_common.partnerDropdowns[mappedKeyJSON.Level] + 1,
        value: "+ Add New",
      },
    ];
    setLevelArr(levelArr.concat(pdata));

    StepperService.setCompDataArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.City],
      setCityArr,
      cityArr
    );
    StepperService.setCompDataArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
      setCurrencyArr,
      currencyArr
    );
    StepperService.setCompDataArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.TravelExpenses],
      setTravelExpense,
      travelExpenseArr
    );

    setCoachingHourRateArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.CoachingHr]
    );
    setAssessmentDayRateArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.AssessmentHourRate]
    );
    setMentoringDayRateArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.MentoringDayRate]
    );
    setFacilitationDayRateArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.facilitationDayRate]
    );
    setCoachingProgrammeRateArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.CoachingProgrammeRate]
    );

    deliveryMethodArr.length = 0;
    setDeliveryMethodArr(
      deliveryMethodArr.concat(
        global_data_common.partnerDropdowns[mappedKeyJSON.DeliveryMethod]
      )
    );

    if (!addNewFlag && global_data.extraQuestion_id != null) {
      setLoading(true);
      AdminPartnerClient.OtherQuestions_get(global_data.extraQuestion_id, {
        partner_profile_id: global_data.partner_profile,
      })
        .then((response: any) => {
          console.log("response: ", response);
          setUserData({
            assessment_hour_rate_id:
              response.data.attributes.assessment_hour_rate_id,
            available_date: response.data.attributes.available_date,
            coaching_hour_id: response.data.attributes.coaching_hour_id,
            facilitation_day_rate_id:
              response.data.attributes.facilitation_day_rate_id,
            mentoring_day_rate_id:
              response.data.attributes.mentoring_day_rate_id,
            coaching_programme_rate_id:
              response.data.attributes.coaching_programme_rate_id,
            psychometric_costs: response.data.attributes.psychometric_costs,
            internal_comments: response.data.attributes.internal_comments,
            coaching_hourly_rate_range:
              response.data.attributes.coaching_hourly_rate_range,
            travel_expenses: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[mappedKeyJSON.TravelExpenses],
              response.data.attributes.travel_expense_id
            ),
            considered_levels: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[mappedKeyJSON.Level],
              response.data.attributes.level_id
            ),
            coach_currency_type: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
              response.data.attributes.coach_currency_type
            ),
            assessment_currency_type: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
              response.data.attributes.assessment_currency_type
            ),
            mentoring_currency_type: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
              response.data.attributes.mentoring_currency_type
            ),
            facilitator_currency_type: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
              response.data.attributes.facilitator_currency_type
            ),
            coaching_program_currency_type: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
              response.data.attributes.coaching_program_currency_type
            ),
            assessor_currency_type: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
              response.data.attributes.assessor_currency_type
            ),
            // facilitator_currency_type: StepperService.getValueFromArrById(
            //   global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
            //   response.data.attributes.facilitator_currency_type
            // ),
            psychometric_costs_currency_type_id:
              StepperService.getValueFromArrById(
                global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
                response.data.attributes.psychometric_costs_currency_type_id
              ),
          });
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.level_id,
            global_data_common.partnerDropdowns[mappedKeyJSON.Level],
            setLevel_attribute,
            level_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.local_tx_areas,
            global_data_common.partnerDropdowns[mappedKeyJSON.City],
            setLocal_tx_areas_attribute,
            local_tx_areas_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.delivery_method_id,
            global_data_common.partnerDropdowns[mappedKeyJSON.DeliveryMethod],
            setDeliveryMethod_attribute,
            deliveryMethod_attribute
          );

          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [addNewFlag]);
  const firstElementRef = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (firstElementRef.current) {
      //@ts-ignore
      firstElementRef.current.scrollIntoView();
    }
  }, []);
  const onChangeMultiItem = (
    obj: any,
    inputId: any,
    routeFrom: any,
    objId: any
  ) => {
    if (routeFrom === "add_in_drop_down") {
      if (inputId === "level_attribute") {
        setLevel_attribute(
          level_attribute.concat({ id: objId, value: obj, label: obj })
        );
      }
      setAddNewFlag(true);
    } else {
      if (inputId === "deliveryMethod_attribute") {
        deliveryMethod_attribute.length = 0;
        setDeliveryMethod_attribute(deliveryMethod_attribute.concat(obj));
      }
      if (inputId === "level_attribute") {
        level_attribute.length = 0;
        setLevel_attribute(level_attribute.concat(obj));
      }
      if (inputId === "local_tx_areas_attribute") {
        local_tx_areas_attribute.length = 0;
        setLocal_tx_areas_attribute(local_tx_areas_attribute.concat(obj));
      }
    }
  };

  const setInputState = (
    inputStateValue: any,
    inputId: any,
    a: any,
    b: any
  ) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
  };
  const onChangeItem = (
    selectedItemValue: any,
    inputId: any,
    routeFrom: any
  ) => {
    if (routeFrom === "add_in_drop_down") {
      setUserData({ ...userData, [inputId]: selectedItemValue });
      setAddNewFlag(true);
    } else if (routeFrom === "selectValue") {
      setUserData({ ...userData, [inputId]: selectedItemValue });
    } else {
      setUserData({
        ...userData,
        [selectedItemValue.id]: selectedItemValue.value,
      });
    }
  };

  const onSubmit = () => {
    var langArr: any =
      local_tx_areas_attribute[0] !== undefined &&
      local_tx_areas_attribute.map((option: any) => option.id);

    var flag = true;

    if (flag) {
      setSubmitClickFlag(false);
      var diagnostic_toolArr: any =
        deliveryMethod_attribute[0] !== undefined &&
        deliveryMethod_attribute.map((option: any) => option.id);
      var levelArr: any =
        level_attribute[0] !== undefined &&
        level_attribute.map((option: any) => option.id);

      var pdata = {
        ...userData,
        coach_currency_type: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
          userData.coach_currency_type
        ),
        assessment_currency_type: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
          userData.assessment_currency_type
        ),
        mentoring_currency_type: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
          userData.mentoring_currency_type
        ),
        facilitator_currency_type: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
          userData.facilitator_currency_type
        ),
        coaching_program_currency_type: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
          userData.coaching_program_currency_type
        ),

        assessor_currency_type: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
          userData.assessor_currency_type
        ),
        psychometric_costs_currency_type_id:
          StepperService.getSelectedIdFromArr(
            global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
            userData.psychometric_costs_currency_type_id
          ),
        // facilitator_currency_type: StepperService.getSelectedIdFromArr(
        //   global_data_common.partnerDropdowns[mappedKeyJSON.Currencies],
        //   userData.facilitator_currency_type
        // ),
        travel_expense_id: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.TravelExpenses],
          userData.travel_expenses
        ),

        coaching_hour_id:
          coachingHourRateArr.length > 0
            ? JSON.stringify(userData.coaching_hour_id)
            : "[]",
        assessment_hour_rate_id:
          assessmentDayRateArr.length > 0
            ? JSON.stringify(userData.assessment_hour_rate_id)
            : "[]",
        coaching_programme_rate_id:
          coachingProgrammeRateArr.length > 0
            ? JSON.stringify(userData.coaching_programme_rate_id)
            : "[]",
        facilitation_day_rate_id:
          facilitationDayRateArr.length > 0
            ? JSON.stringify(userData.facilitation_day_rate_id)
            : "[]",
        mentoring_day_rate_id:
          mentoringDayRateArr.length > 0
            ? JSON.stringify(userData.mentoring_day_rate_id)
            : "[]",

        level_id: levelArr.length > 0 ? JSON.stringify(levelArr) : "[]",
        local_tx_areas: langArr.length > 0 ? JSON.stringify(langArr) : "[]",
        delivery_method_id:
          diagnostic_toolArr.length > 0
            ? JSON.stringify(diagnostic_toolArr)
            : "[]",
      };
      setLoading(true);

      if (global_data.extraQuestion_id == null) {
        AdminPartnerClient.OtherQuestions(
          ObjectToFormdata({
            partner_profile_id: global_data.partner_profile,
            ...pdata,
          })
        )
          .then((response: any) => {
            dispatch({
              type: GLOBAL_STEPPER_DATA,
              payload: { extraQuestion_id: response.data.id },
            });
            props.parentHandleNext(props.activeIndex + 1);
            dispatch(
              showSnackbar("Success", ["Information saved successfully"])
            );
            setLoading(false);
          })
          .catch((error) => {
            dispatch(showSnackbar("error", ["" + error.errors[0]]));
            setLoading(false);
          });
      } else {
        AdminPartnerClient.OtherQuestions_put(
          global_data.extraQuestion_id,
          ObjectToFormdata({
            partner_profile_id: global_data.partner_profile,
            ...pdata,
          })
        )
          .then((response: any) => {
            props.parentHandleNext(props.activeIndex + 1);
            dispatch(
              showSnackbar("Success", ["Information updated successfully"])
            );
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    } else {
      setSubmitClickFlag(true);
    }
  };
  const onBack = () => {
    props.parentHandleNext(props.activeIndex - 1);
  };

  const handleMultileCheckbox = (
    filedKey: string,
    value: string,
    isChecked: boolean,
    id: number
  ) => {
    const selectedItem = userData[filedKey] ? [...userData[filedKey]] : [];
    if (isChecked) {
      selectedItem.push(id);
    } else {
      const unselectIndex = selectedItem.findIndex((item) => item === id);
      selectedItem.splice(unselectIndex, 1);
    }
    setUserData({
      ...userData,
      [filedKey]: [...selectedItem],
    });
    if (filedKey === "coaching_hour_id") {
      const filterData = coachingHourRateArr
        .filter((r: any) => [...selectedItem].includes(r.id))
        .map((r: any) => r.value);
      dispatch({
        type: GLOBAL_STEPPER_DATA,
        payload: { coaching_hr_id: filterData },
      });
    }
  };

  return (
    <div style={{ marginBottom: 40 }} ref={firstElementRef}>
      <Grid
        container
        direction="row"
        alignItems="flex-start"
        style={{ padding: 30 }}
      >
        <Grid item xs={10}>
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            style={{ marginBottom: 30 }}
            spacing={1}
          >
            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Minimum coach rate
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Please select all that apply
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                value={userData.coach_currency_type}
                id="coach_currency_type"
                options={filteredCurrencyArr}
                style={{ width: "100%" }}
                className={classes.autoComplete}
                onChange={(e: any) => {
                  setUserData({
                    ...userData,
                    ["coach_currency_type"]: e.target.textContent,
                  });
                }}
                renderInput={(params: any) => (
                  <TextField
                    placeholder="Currency"
                    className="custom_autocomplete"
                    {...params}
                    style={{ borderWidth: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid container xs={7}>
              {coachingHourRateArr.map((rate: any) => (
                <Grid item xs={4} key={rate.id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={userData?.coaching_hour_id?.includes(rate.id)}
                        onChange={(event) =>
                          handleMultileCheckbox(
                            "coaching_hour_id",
                            rate,
                            event.target.checked,
                            rate.id
                          )
                        }
                        name="coaching_hour_id"
                        id="coaching_hour_id"
                      />
                    }
                    label={<Typography variant="h2">{rate.value}</Typography>}
                  />
                </Grid>
              ))}
            </Grid>

            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Assessment day rates
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Please select all that apply
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                value={userData.assessment_currency_type}
                id="assessment_currency_type"
                options={filteredCurrencyArr}
                style={{ width: "100%" }}
                className={classes.autoComplete}
                onChange={(e: any) => {
                  setUserData({
                    ...userData,
                    ["assessment_currency_type"]: e.target.textContent,
                  });
                }}
                renderInput={(params: any) => (
                  <TextField
                    placeholder="Currency"
                    className="custom_autocomplete"
                    {...params}
                    style={{ borderWidth: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid container xs={7}>
              {assessmentDayRateArr.map((rate: any) => (
                <Grid item xs={4} key={rate.id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={userData?.assessment_hour_rate_id?.includes(
                          rate.id
                        )}
                        name="assessment_hour_rate_id"
                        id="assessment_hour_rate_id"
                        onChange={(event) =>
                          handleMultileCheckbox(
                            "assessment_hour_rate_id",
                            rate,
                            event.target.checked,
                            rate.id
                          )
                        }
                      />
                    }
                    label={<Typography variant="h2">{rate.value}</Typography>}
                  />
                </Grid>
              ))}
            </Grid>
            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Mentoring day rates
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Please select all that apply
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                value={userData.mentoring_currency_type}
                id="mentoring_currency_type"
                options={filteredCurrencyArr}
                style={{ width: "100%" }}
                className={classes.autoComplete}
                onChange={(e: any) => {
                  setUserData({
                    ...userData,
                    ["mentoring_currency_type"]: e.target.textContent,
                  });
                }}
                renderInput={(params: any) => (
                  <TextField
                    placeholder="Currency"
                    className="custom_autocomplete"
                    {...params}
                    style={{ borderWidth: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid container xs={7}>
              {mentoringDayRateArr.map((rate: any) => (
                <Grid item xs={4} key={rate.id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        value={rate.id}
                        checked={userData?.mentoring_day_rate_id?.includes(
                          rate?.id
                        )}
                        // id={rate}
                        onChange={(event) =>
                          handleMultileCheckbox(
                            "mentoring_day_rate_id",
                            rate,
                            event.target.checked,
                            rate.id
                          )
                        }
                        name="mentoring_day_rate_id"
                        id="mentoring_day_rate_id"
                      />
                    }
                    label={<Typography variant="h2">{rate.value}</Typography>}
                  />
                </Grid>
              ))}
            </Grid>

            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Facilitation day rates
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Please select all that apply
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                value={userData.facilitator_currency_type}
                id="facilitator_currency_type"
                options={filteredCurrencyArr}
                style={{ width: "100%" }}
                className={classes.autoComplete}
                onChange={(e: any) => {
                  setUserData({
                    ...userData,
                    ["facilitator_currency_type"]: e.target.textContent,
                  });
                }}
                renderInput={(params: any) => (
                  <TextField
                    placeholder="Currency"
                    className="custom_autocomplete"
                    {...params}
                    style={{ borderWidth: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid container xs={7}>
              {facilitationDayRateArr.map((rate: any) => (
                <Grid item xs={4} key={rate.id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="facilitation_day_rate_id"
                        name="facilitation_day_rate_id"
                        color="primary"
                        checked={userData?.facilitation_day_rate_id?.includes(
                          rate.id
                        )}
                        onChange={(event) =>
                          handleMultileCheckbox(
                            "facilitation_day_rate_id",
                            rate,
                            event.target.checked,
                            rate.id
                          )
                        }
                      />
                    }
                    label={<Typography variant="h2">{rate.value}</Typography>}
                  />
                </Grid>
              ))}
            </Grid>

            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Coaching program rates
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Please select all that apply
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                value={userData.coaching_program_currency_type}
                id="coaching_program_currency_type"
                options={filteredCurrencyArr}
                style={{ width: "100%" }}
                className={classes.autoComplete}
                onChange={(e: any) => {
                  setUserData({
                    ...userData,
                    ["coaching_program_currency_type"]: e.target.textContent,
                  });
                }}
                renderInput={(params: any) => (
                  <TextField
                    placeholder="Currency"
                    className="custom_autocomplete"
                    {...params}
                    style={{ borderWidth: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid container xs={7}>
              {coachingProgrammeRateArr.map((rate: any) => (
                <Grid item xs={4} key={rate.id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        name="coaching_programme_rate_id"
                        defaultChecked={userData?.coaching_programme_rate_id?.includes(
                          rate.id
                        )}
                        checked={userData?.coaching_programme_rate_id?.includes(
                          rate.id
                        )}
                        id="coaching_programme_rate_id"
                        onChange={(event) =>
                          handleMultileCheckbox(
                            "coaching_programme_rate_id",
                            rate,
                            event.target.checked,
                            rate.id
                          )
                        }
                      />
                    }
                    label={<Typography variant="h2">{rate.value}</Typography>}
                  />
                </Grid>
              ))}
            </Grid>

            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Coaching hourly rate range
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <CustomInput
                variant="outlined"
                placeholder="Coaching hourly rate range"
                multiline="true"
                label="Limited Text (50 characters)"
                fullWidth
                value={userData.coaching_hourly_rate_range}
                // onChange={handleTextChange}
                parentcall={setInputState}
                inputProps={{ maxLength: 50 }}
                rows={4}
                id="coaching_hourly_rate_range"
              />
            </Grid>
          </Grid>

          {role === "admin" && (
            <Grid
              container
              direction="row"
              alignItems="flex-start"
              style={{ marginBottom: 30 }}
            >
              <Grid item xs={3}>
                <Typography variant="h2" style={{ padding: "8px 8px" }}>
                  Travel expenses
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <CustomSelect
                  id="travel_expenses"
                  drop_down="TravelExpense"
                  addNewFlag={true}
                  field_name="travel_expenses"
                  addNewHandler={addNewHandler}
                  labelText="Select travel expenses"
                  displayEmpty
                  variant="outlined"
                  itemArr={travelExpenseArr}
                  parentcall={onChangeItem}
                  defaultValue={userData.travel_expenses}
                />
              </Grid>
            </Grid>
          )}
          <Grid
            container
            direction="row"
            alignItems="center"
            style={{ marginBottom: 30 }}
            spacing={1}
          >
            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Psychometric costs
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <CustomInput
                id="psychometric_costs"
                variant="outlined"
                placeholder="Psychometric costs"
                parentcall={setInputState}
                value={userData.psychometric_costs}
              />
            </Grid>
            <Grid item xs={2}>
              <Autocomplete
                value={userData.psychometric_costs_currency_type_id}
                id="psychometric_costs_currency_type_id"
                options={filteredCurrencyArr}
                style={{ width: "100%" }}
                className={classes.autoComplete}
                onChange={(e: any) => {
                  setUserData({
                    ...userData,
                    ["psychometric_costs_currency_type_id"]:
                      e.target.textContent,
                  });
                }}
                renderInput={(params: any) => (
                  <TextField
                    placeholder="Currency"
                    className="custom_autocomplete"
                    {...params}
                    style={{ borderWidth: 1 }}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            alignItems="center"
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Which cities would you NOT charge travel for
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <CustomSelectMulti
                id="local_tx_areas_attribute"
                itemArr={local_tx_areasArr}
                parentcall={onChangeMultiItem}
                placeholder="Select city"
                value={local_tx_areas_attribute}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            alignItems="center"
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={3}>
              <Typography variant="h2" style={{ padding: "8px 8px" }}>
                Delivery method
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <CustomSelectMulti
                id="deliveryMethod_attribute"
                itemArr={deliveryMethodArr}
                parentcall={onChangeMultiItem}
                placeholder="Select delivery method"
                helperText={
                  submitClickFlag && deliveryMethod_attribute.length === 0
                    ? "Please select delivery method"
                    : ""
                }
                error={
                  submitClickFlag && deliveryMethod_attribute.length === 0
                    ? true
                    : false
                }
                value={deliveryMethod_attribute}
              />
            </Grid>
          </Grid>
          {role === "admin" && (
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{ marginBottom: 30 }}
            >
              <Grid item xs={3}>
                <Typography variant="h2" style={{ padding: "8px 8px" }}>
                  Levels Acuity would consider them for
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <CustomSelectMulti
                  id="level_attribute"
                  itemArr={levelArr}
                  drop_down="Level"
                  addNewHandler={addNewHandler}
                  field_name="level"
                  addNewFlag={true}
                  parentcall={onChangeMultiItem}
                  placeholder="Select levels Acuity"
                  value={level_attribute}
                />
              </Grid>
            </Grid>
          )}
          {role === "admin" && (
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{ marginBottom: 30 }}
              spacing={1}
            >
              <Grid item xs={3}>
                <Typography variant="h2" style={{ padding: "8px 8px" }}>
                  Commercials and delivery comments
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <CustomInput
                  id="internal_comments"
                  variant="outlined"
                  placeholder="Commercials and delivery comments"
                  multiline={true}
                  rows={4}
                  parentcall={setInputState}
                  value={userData.internal_comments}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Header
        isBack={true}
        saveBtnTitle={"Save & Proceed"}
        parentcall={onSubmit}
        parentBackCall={onBack}
      />
      {showAddNewModalExist && showAddNewModal && (
        <AddToListModal
          type="partner_profiles"
          id={global_data.partner_profile}
          postData={{ ...addNewModalProps }}
        />
      )}
      {loading && <CircularIndeterminate />}
    </div>
  );
}

export default OtherQuestions;
